module.exports = __webpack_public_path__ + "img/christmas_share_btn.97531397.png";